import { $axios } from 'boot/axios';

const initialState = () => ({
  providers: [],
});

const actions = {
  // Payment providers
  async fetchProviders({ commit }) {
    const { data } = await $axios.get('gateways');
    commit('setProviders', data.data.elements);
  },
  async createProvider({ dispatch }, provider) {
    const { data } = await $axios.post('gateways', provider);
    await dispatch('fetchProviders');
    return data;
  },
  async updateProvider({ dispatch }, { id, body }) {
    await $axios.put(`gateways/${id}`, body);
    await dispatch('fetchProviders');
  },
  async removeProvider({ dispatch }, id) {
    await $axios.delete(`gateways/${id}`);
    await dispatch('fetchProviders');
  },
};

const mutations = {
  setProviders(state, payload) {
    state.providers = payload;
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
